export class PaymentDetailModel {
  constructor() {
    this.boostPlanId = null;
    this.stripeTokenId = "";
    this.improvementPlanId = null;
  }
}
